module.exports = __webpack_public_path__ + "img/catering-banner-catalogue.1ce8803d.svg";